import About from "../Components/About/About";
import Layout from "../Components/Layout";
import NewBooks from "../Components/NewBooks/NewBooks";
import News from "../Components/News/News";

const App = () => {
    return (
        <>
            <Layout>
                <News />
                <About />
                <NewBooks />
            </Layout>
        </>
    );
};

export default App;
